// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file common/common_responses.proto (package com.gem.bff.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

/**
 * Describes the file common/common_responses.proto.
 */
export const file_common_common_responses: GenFile =
  /*@__PURE__*/
  fileDesc(
    'Ch1jb21tb24vY29tbW9uX3Jlc3BvbnNlcy5wcm90bxIUY29tLmdlbS5iZmYuY29udHJhY3QiIgoPQm9vbGVhblJlc3BvbnNlEg8KB3N1Y2Nlc3MYASABKAhCHgoaY29tLmdlbS5iZmYuY2FsbHMuY29udHJhY3RQAWIGcHJvdG8z'
  );

/**
 * @generated from message com.gem.bff.contract.BooleanResponse
 */
export type BooleanResponse = Message<'com.gem.bff.contract.BooleanResponse'> & {
  /**
   * @generated from field: bool success = 1;
   */
  success: boolean;
};

/**
 * Describes the message com.gem.bff.contract.BooleanResponse.
 * Use `create(BooleanResponseSchema)` to create a new message.
 */
export const BooleanResponseSchema: GenMessage<BooleanResponse> =
  /*@__PURE__*/
  messageDesc(file_common_common_responses, 0);
